"use strict";
// full errors codes list: https://jirasumoscheduler.atlassian.net/wiki/external/MDgzZmIwNDdiM2E4NDVjNWE2YzQyYzU2MDg0ZDY4Yjc
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLIENT_ERROR_CODES = exports.SERVER_ERROR_CODES = exports.TOAST_ERROR_CODES = exports.MS_DYNAMICS_ERROR_CODES = exports.GLOBAL_ERROR_CODES = exports.STANDARD_ERROR_CODES = void 0;
var STANDARD_ERROR_CODES;
(function (STANDARD_ERROR_CODES) {
    STANDARD_ERROR_CODES["BAD_REQUEST"] = "400";
    STANDARD_ERROR_CODES["FORBIDDEN"] = "403";
    STANDARD_ERROR_CODES["NOT_FOUND"] = "404";
    STANDARD_ERROR_CODES["NO_PERMISSIONS"] = "405";
    STANDARD_ERROR_CODES["INTERNAL_SERVER_ERROR"] = "500";
})(STANDARD_ERROR_CODES = exports.STANDARD_ERROR_CODES || (exports.STANDARD_ERROR_CODES = {}));
var GLOBAL_ERROR_CODES;
(function (GLOBAL_ERROR_CODES) {
    GLOBAL_ERROR_CODES["UNPROCESSABLE_ENTITY"] = "422";
    GLOBAL_ERROR_CODES["LICENSE_EXPIRED"] = "423";
    GLOBAL_ERROR_CODES["WORKSPACE_DEACTIVATED"] = "424";
    GLOBAL_ERROR_CODES["INVALID_SESSION"] = "425";
    GLOBAL_ERROR_CODES["MEETING_TYPE_EXPIRED"] = "443";
    GLOBAL_ERROR_CODES["HOST_DEACTIVATED"] = "446";
    GLOBAL_ERROR_CODES["INTEGRATION_ERRORS"] = "447";
})(GLOBAL_ERROR_CODES = exports.GLOBAL_ERROR_CODES || (exports.GLOBAL_ERROR_CODES = {}));
var MS_DYNAMICS_ERROR_CODES;
(function (MS_DYNAMICS_ERROR_CODES) {
    MS_DYNAMICS_ERROR_CODES["ROLE_DEACTIVATED"] = "460";
    MS_DYNAMICS_ERROR_CODES["USER_DEACTIVATED"] = "461";
})(MS_DYNAMICS_ERROR_CODES = exports.MS_DYNAMICS_ERROR_CODES || (exports.MS_DYNAMICS_ERROR_CODES = {}));
var TOAST_ERROR_CODES;
(function (TOAST_ERROR_CODES) {
    TOAST_ERROR_CODES["LICENSE_BASIC_LIMITS"] = "462";
    TOAST_ERROR_CODES["ROLE_CAN_T_BE_DELETED"] = "463";
    TOAST_ERROR_CODES["FAILED_TO_SWITCH_ACCOUNT"] = "464";
    TOAST_ERROR_CODES["MEETING_TYPE_HAS_EXPIRED"] = "465";
    TOAST_ERROR_CODES["NO_AVAILABLE_USERS_ON_THE_SELECTED_TIME"] = "466";
    TOAST_ERROR_CODES["USER_NOT_FOUND_WHEN_TRYING_TO_LOGIN"] = "467";
    TOAST_ERROR_CODES["ITEM_LIMITS"] = "468";
    TOAST_ERROR_CODES["ERROR_WITH_CREDIT_CARD"] = "469";
    TOAST_ERROR_CODES["ERROR_WITH_TRY_TO_PAY_MANUALLY"] = "470";
    TOAST_ERROR_CODES["FAILED_TO_PAY_ONE_OR_MORE_OUTSTANDING_INVOICES"] = "471";
    TOAST_ERROR_CODES["ALL_SUBSCRIPTION_PLANS_RESTRICTIONS"] = "472";
    TOAST_ERROR_CODES["ADMIN_DATA_RECORD_WITH_THIS_EMAIL_ALREADY_CREATED_FOR_THIS_ORG"] = "473";
    TOAST_ERROR_CODES["IMPORT_CONTACTS_ERROR"] = "474";
    TOAST_ERROR_CODES["INVALID_COUPON_CHARGEBEE"] = "475";
    TOAST_ERROR_CODES["DUPLICATE_ENGAGE_LINK"] = "476";
    TOAST_ERROR_CODES["EVENT_UPDATE_CANCEL_BLOCK"] = "477";
    TOAST_ERROR_CODES["CALL_PLAN_LIMIT_ERROR"] = "478";
})(TOAST_ERROR_CODES = exports.TOAST_ERROR_CODES || (exports.TOAST_ERROR_CODES = {}));
exports.SERVER_ERROR_CODES = {
    ...STANDARD_ERROR_CODES,
    ...GLOBAL_ERROR_CODES,
    ...MS_DYNAMICS_ERROR_CODES,
    ...TOAST_ERROR_CODES,
};
var CLIENT_ERROR_CODES;
(function (CLIENT_ERROR_CODES) {
    CLIENT_ERROR_CODES["NO_ACTIVE_WORKSPACES"] = "NO_ACTIVE_WORKSPACES";
    CLIENT_ERROR_CODES["SCHEDULER_TIME_SLOT_TO_SHORT"] = "SCHEDULER_TIME_SLOT_TO_SHORT";
})(CLIENT_ERROR_CODES = exports.CLIENT_ERROR_CODES || (exports.CLIENT_ERROR_CODES = {}));
